import React from "react";

const PictureDisplay = ({ src, srcset, viewWidth, id, style, className, alt, link = "", target = "" }, ref) => {
    if (link && link !== "https://" && link !== "123") {
        return <a href={link.startsWith("http") ? link : `https://${link}`} target={target ? target : "_self"}>
            <picture>
                <source
                    type={"image/webp"}
                    srcSet={srcset}
                    sizes={viewWidth ?? "100vw"}
                />
                <img src={src} id={id} ref={ref} style={style} className={className} alt={alt} />
            </picture>
        </a>
    }
    return (
        <picture>
            <source
                type={"image/webp"}
                srcSet={srcset}
                sizes={viewWidth ?? "100vw"}
            />
            <img src={src} id={id} ref={ref} style={style} className={className} alt={alt} />
        </picture>
    );
}
export default React.forwardRef(PictureDisplay) 